export default "__VITE_ASSET__c6211693__"